import ProductCard from '../product-card/ProductCard.vue';

export default {
  name: 'ProductConfiguratorResult',
  components: {
    ProductCard
  },
  data() {
    return {
      selectedFinish: null
    };
  },
  props: {
    filteredFinish: null,
    setSpecLink: Function,
    result: {type: Object, required: true},
    level: {type: String, required: true},
    productType: {type: String, required: true}
  },
  template: `
    <ProductCard
      @share="setSpecLink"
      :level="level"
      :product-type="productType"
      :result="result"
      :default-finish="filteredFinish"
      :product-url="result.product_url"
      :product-finishes="result.product_finish_images"
      :product-lowest-price="result.product_lowest_price"
      :product-id="result.product_id"
      :product-image="result.product_image"
      :product-line="result.product_product_line"
      :product-title="result.product_title"
      :product-description="result.product_description"
      :variation-description="result.variation_description"
      :variation-list-price="result.variation_list_price"
      :variation-image="result.variation_image"
      :variation-sku="result.variation_sku"
      :variation-title="result.variation_title"
      :variation-part-number="result.variation_part_number"
      :variation-channel-advisor-enabled="result.variation_channel_advisor_enabled"
      :variation-marketplace="result.variation_marketplace"
    />`
};
